export default {
  default_program_name: 'Rewards Club',
  message: 'Join <highlight>{{name}}</highlight> — earn {{reward}} for every {{spend}} spent & unlock free menu items!',
  buttons: {
    join_now: 'Join Now',
  },
};
